<template>
  <v-app>
    <portal-sysbar :show-customer="false"></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title :title="$t('message.aside.adminloco')"></portal-title>
      <portal-breadcumb></portal-breadcumb>
      <div class="content">
        <v-row>
          <v-col class="d-flex" cols="12" sm="4" md="3">
            <v-autocomplete :items="ecmList"  outlined dense hide-details solo item-value="id"
            item-text="name" label="ECM"  @change="filterByEcm"></v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4" md="3">
            <v-autocomplete v-model="selectedAsset" :items="assetList"
            :label="$t('message.infoloc.locomotive', { value: 'default' })"
            outlined dense hide-details solo @change="loadLoco"></v-autocomplete>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn class="mr-2" color="#CCD2D5" @click="setSignalement(true)">
              <v-icon>mdi-plus</v-icon>
              {{ $t("message.magic.sr", { value: "default" }) }}
            </v-btn>
            <v-btn color="#CCD2D5" @click="setKm(true)">
              <v-icon>mdi-plus</v-icon>
              {{ $t("message.magic.mileage", { value: "default" }) }}
            </v-btn>
          </v-col>
        </v-row>
        
        <v-row v-if="asset">
          <v-tabs v-model="tab" color="basil" grow class="mb-1">
            <v-tab key="data">
              Data
            </v-tab>
            <v-tab key="history">
              History
            </v-tab>
            <v-tab key="wheelset">
              Wheelset
            </v-tab>
            <v-tab key="contract">
              Contract
            </v-tab>
          </v-tabs>
          
          
          <v-tabs-items v-model="tab" class="tab-content">
            <v-tab-item key="data">
              <v-row>
                <v-col>
                  <v-card class="mb-3" elevation="0">
                    <v-card-title class="portal-deep-blue-bg">
                      Master Data
                    </v-card-title>
                    
                    <v-card-text class="mt-5">
                      <v-simple-table class="dp-gray" dense>
                        <template v-slot:default>
                          <thead></thead>
                          <tbody>
                            <tr>
                              <th class="text-left shrink" colspan="2">Description</th>
                              <td colspan="2">{{ asset?.asset?.description }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="2">UIC number</th>
                              <td colspan="2">{{ asset?.asset?.uicnumber }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="2">Manufacturer</th>
                              <td colspan="2">{{ asset?.asset?.manufacturer }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="2">
                                Date of Manufacture
                              </th>
                              <td colspan="2">
                                {{ formatdate(asset?.asset?.manufacturerDate) }}
                              </td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="2">Owner</th>
                              <td colspan="2">{{ asset?.asset?.owner }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="2">Operator</th>
                              <td colspan="2">{{ asset?.asset?.operator?.name }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="1">ECM 1</th>
                              <td colspan="3">{{ asset?.asset?.ecm1?.name }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="1">ECM 2</th>
                              <td colspan="3">{{ asset?.asset?.ecm2?.name }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="1">ECM 3</th>
                              <td colspan="3">{{ asset?.asset?.ecm3?.name }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="1">ECM 4</th>
                              <td class="text-left" colspan="3">
                                {{ asset?.asset?.ecm4?.name }}
                              </td>
                            </tr>
                            <tr>
                              <th class="text-left shrink" colspan="1">
                                {{ $t("message.infoloc.cert", { value: "default" }) }}
                              </th>
                              <td colspan="3">
                                <span class="mr-2" v-for="item in homologations" :key="item.assetspedid">{{
                                  item.assetattrid.description }},
                                </span>
                                <!-- TODO replace with operabilities -->
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card class="mb-6" elevation="0">
                    <v-card-title class="portal-deep-blue-bg">
                      {{ $t("message.infoloc.infoOp", { value: "default" }) }}
                    </v-card-title>
                    <v-card-text class="mt-5">
                      <v-simple-table class="dp-gray" dense>
                        <template v-slot:default>
                          <thead>
                          </thead>
                          
                          <tbody>
                            <tr>
                              <th class="text-left shrink">
                                {{ $t("message.infoloc.softwareversion", { value: "default", }) }}
                              </th>
                              <td>{{ asset?.asset?.softwareversion }}</td>
                            </tr>
                            
                            <tr>
                              <th class="text-left shrink">
                                {{ $t("message.infoloc.engineeringvariant", { value: "default", }) }}
                              </th>
                              <td>{{ asset?.asset?.engineeringvariant }}</td>
                            </tr>
                            
                            <tr>
                              <th class="text-left shrink">
                                {{ $t("message.page.status", { value: "default" }) }}
                              </th>
                              <td>{{ asset?.asset?.status }}</td>
                            </tr>
                            
                            <tr>
                              <th class="text-left shrink">
                                {{ $t("message.magic.restriction", { value: "default" }) }}
                              </th>
                              <td>{{ remark }}</td>
                            </tr>
                            
                            <tr>
                              <th class="text-left shrink">
                                {{ $t("message.page.locate", { value: "default" }) }}
                              </th>
                              <td>{{ workorder?.location }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink">
                                {{ $t("message.infoloc.actWorkorder", { value: "default", }) }}
                              </th>
                              <td>{{ workorder?.description }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink">
                                {{ $t("message.infoloc.outPrevDate", { value: "default", }) }}
                              </th>
                              <td>{{ formatdate(workorder?.schedfinish) }}</td>
                            </tr>
                            <tr>
                              <th class="text-left shrink">
                                {{ $t("message.infoloc.unitToGo", { value: "default" }) }}
                              </th>
                              <td>{{ pleft }}</td>
                            </tr>
                            
                            <tr>
                              <th class="text-left shrink">
                                {{ $t("message.infoloc.nextWorkDate", { value: "default", }) }}
                              </th>
                              <td>{{ formatdate(calcduedate) }}</td>
                            </tr>
                            
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            
            
            <v-tab-item key="history">        
              <v-card class="mb-3">
                <v-card-title class="portal-deep-blue-bg">
                  {{ $t("message.infoloc.sr", { value: "default" }) }}
                </v-card-title>
                <v-card-text class="mt-5">
                  <v-data-table :items="srs" :headers="headerSrTable" :items-per-page="5" :search="search" dense>
                    <template v-slot:top>
                      <v-row>
                        <v-col offset-md="8">
                          <v-text-field v-model="search" append-icon="mdi-magnify"
                          :label="$t('message.search', { value: 'default' })" single-line hide-details></v-text-field>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.reportdate`]="{ item }">
                      {{ formatdate(item.reportdate) }}
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      {{ getSrStatusText(item.status) }}
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-icon @click="showSrDetails(item.ticketid)">
                        mdi-eye
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              
              <v-row>
                <v-col>
                  <v-card ref="kmHistory" class="mb-3">
                    <v-card-title class="portal-deep-blue-bg">
                      {{ $t("message.infoloc.hkm", { value: "default" }) }}
                      <v-col class="py-0 text-right">
                        <vue-excel-xlsx :data="meterKMdatas" :columns="getExportColumns" :file-name="'history_KM'"
                        :file-type="'xlsx'" :sheet-name="'history'">
                          <v-icon large color="green">mdi-file-excel</v-icon>
                        </vue-excel-xlsx>
                      </v-col>
                    </v-card-title>
                    <v-card-text class="mt-5">
                      <v-data-table :items="meterKMdatas" :headers="headerMeterTable" :items-per-page="5" dense>
                        <template v-slot:[`item.readingdate`]="{ item }">
                          {{ formatdate(item.readingdate) }}
                        </template>
                        <template v-slot:[`item.readingsource`]="{ item }">
                          {{ getSource(item.readingsource) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card ref="hmHistory" class="mb-3">
                    <v-card-title class="portal-deep-blue-bg">
                      {{ $t("message.infoloc.hhm", { value: "default" }) }}
                      <v-col class="py-0 text-right">
                        <vue-excel-xlsx :data="meterHMdatas" :columns="getExportColumns" :file-name="'history_HM'"
                        :file-type="'xlsx'" :sheet-name="'history'">
                          <v-icon large color="green">mdi-file-excel</v-icon>
                        </vue-excel-xlsx>
                      </v-col>
                    </v-card-title>
                    <v-card-text class="mt-5">
                      <v-data-table :items="meterHMdatas" :headers="headerMeterTable" :items-per-page="5" dense>
                        <template v-slot:[`item.readingdate`]="{ item }">
                          {{ formatdate(item.readingdate) }}
                        </template>
                        <template v-slot:[`item.readingsource`]="{ item }">
                          {{ getSource(item.readingsource) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
        
        
            <v-tab-item key="wheelset">
              <v-card class="mb-3">
                <v-card-title class="portal-deep-blue-bg">
                  {{ $t("message.infoloc.wheelset", { value: "default" }) }}
                </v-card-title>
                <v-card-text>
                  <div class="text-subtitle-2 my-2">
                    <b>
                      {{ $t("message.magic.date", { value: "default" }) }}:
                      {{ wheelsets[0]?.measuredate }}
                    </b>
                  </div>
                  <v-row class="mt-5 ">
                    
                    <v-col class="text-center d-flex justify-center">
                      <v-sheet width="300" class="mx-3">
                        
                        <div class="d-flex flex-column wheel">
                          <!-- wheel measure right -->
                          <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                            <v-row>
                              <v-col class="schema-text text-left">
                                R:{{ wheelsets[0]?.measures[wheelsetsNums[0]]?.dright }}
                              </v-col>
                              <v-col class="schema-text text-right">
                                R:{{ wheelsets[0]?.measures[wheelsetsNums[1]]?.dright }}
                              </v-col>
                            </v-row>
                          </v-card>
                          
                          <!--wheel nums-->
                          <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                            <v-row>
                              <v-col class="schema-text text-left pl-7">
                                <b>{{ wheelsetsNums[0] }}</b>
                              </v-col>
                              <v-col class="schema-text">
                                <b>{{ wheelsetsNums[1] }}</b>
                              </v-col>
                            </v-row>
                          </v-card>
                          
                          <!-- wheel measure left -->
                          <v-card color="rgba(255, 255, 255, 0)" elevation="0">
                            <v-row>
                              <v-col class="schema-text text-left">
                                L:{{ wheelsets[0]?.measures[wheelsetsNums[0]]?.dleft }}
                              </v-col>
                              <v-col class="schema-text text-right">
                                L:{{ wheelsets[0]?.measures[wheelsetsNums[1]]?.dleft }}
                              </v-col>
                            </v-row>
                          </v-card>
                        </div>
                        <img src="@/assets/wheels.png" height="200" alt="logo" style="display: block; margin: auto; " />
                      </v-sheet>
                    </v-col>
                    <v-col class="text-center d-flex justify-center">
                      <v-sheet width="300" class="mx-3">
                        
                        <div class="d-flex flex-column wheel">
                          <!-- wheel measure right -->
                          <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                            <v-row>
                              <v-col class="schema-text text-left">
                                R:{{ wheelsets[0]?.measures[wheelsetsNums[2]]?.dright }}
                              </v-col>
                              <v-col class="schema-text text-right">
                                R:{{ wheelsets[0]?.measures[wheelsetsNums[3]]?.dright }}
                              </v-col>
                            </v-row>
                          </v-card>
                          <!--wheel nums-->
                          <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                            <v-row>
                              <v-col class="schema-text text-left pl-7">
                                <b>{{ wheelsetsNums[2] }}</b>
                              </v-col>
                              <v-col class="schema-text">
                                <b>{{ wheelsetsNums[3] }}</b>
                              </v-col>
                            </v-row>
                          </v-card>
                          
                          <!-- wheel measure left -->
                          <v-card color="rgba(255, 255, 255, 0)" elevation="0">
                            <v-row>
                              <v-col class="schema-text text-left">
                                L:{{ wheelsets[0]?.measures[wheelsetsNums[2]]?.dleft }}
                              </v-col>
                              <v-col class="schema-text text-right">
                                L:{{ wheelsets[0]?.measures[wheelsetsNums[3]]?.dleft }}
                              </v-col>
                            </v-row>
                          </v-card>
                        </div>
                        <img src="@/assets/wheels.png" height="200" alt="logo" style="display: block; margin: auto; " />
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card class="mb-3">
                
                <v-card-title class="portal-deep-blue-bg">
                  {{ $t("message.aside.history", { value: "default" }) }}
                </v-card-title>
                <v-card-text>
                  <v-row class="text-center">
                    <v-col>
                      <v-data-table :items="wheelsets" :items-per-page="5" dense class="mt-3">
                        <template v-slot:header="{ props: {} }">
                          <thead>
                            <tr>
                              <th>&nbsp;</th>
                              <template v-for="wheel in wheelsetsNums">
                                <th style="cursor: pointer" :key="wheel.concat('-', 'left')">
                                  D LEFT
                                </th>
                                <th style="cursor: pointer" :key="wheel.concat('-', 'right')">
                                  D RIGHT
                                </th>
                              </template>
                            </tr>
                          </thead>
                        </template>
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="item in items" :key="item.measuredate">
                              <td>{{ item?.measuredate }}</td>
                              <td>{{ item?.measures[wheelsetsNums[0]]?.dleft }}</td>
                              <td>
                                {{ item?.measures[wheelsetsNums[0]]?.dright }}
                              </td>
                              <td>{{ item?.measures[wheelsetsNums[1]]?.dleft }}</td>
                              <td>{{ item?.measures[wheelsetsNums[1]]?.dright }}</td>
                              <td>{{ item?.measures[wheelsetsNums[2]]?.dleft }}</td>
                              <td>{{ item?.measures[wheelsetsNums[2]]?.dright }}</td>
                              <td>{{ item?.measures[wheelsetsNums[3]]?.dleft }}</td>
                              <td>{{ item?.measures[wheelsetsNums[3]]?.dright }}</td>
                              <td>
                                <v-icon v-if="checkWo(item)" @click="downloadProtocol(item)">mdi-eye</v-icon>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="contract">
              <v-card class="mb-3" elevation="0">
                <v-card-title class="portal-deep-blue-bg">
                  Contract data
                </v-card-title>
                
                <v-card-text class="mt-5">
                  <v-simple-table class="dp-gray" dense>
                    <template v-slot:default>
                      <thead></thead>
                      <tbody>
                        <tr>
                          <th class="text-left shrink" colspan="2">Constructor warranty</th>
                          <td colspan="2">{{ asset?.asset?.warranty }}</td>
                        </tr>
                        <tr>
                          <th class="text-left shrink" colspan="2">ECM3 person</th>
                          <td colspan="2">{{ asset?.asset?.ecm3person }}</td>
                        </tr>
                        <tr>
                          <th class="text-left shrink" colspan="2">ECM3 deputy</th>
                          <td colspan="2">{{ asset?.asset?.ecm3deputy }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-row>
        <div v-else class="mt-3">
          <b>Aucune locomotive selectionnée</b>
        </div>
      </div>
    </div>
    <v-dialog v-model="signalDialog" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
      <portal-signalement :assets="modalAssetList" :customer="getterCurrentClient" :user="getterContact"
      v-on:srClose="setSignalement(false)" has-hotline></portal-signalement>
    </v-dialog>
    <v-dialog v-model="kmDialog" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
      <portal-km v-on:kmClose="setKm(false)" :assets="modalAssetList" :customer="getterCurrentClient"
      :user="getterContact.mail"></portal-km>
    </v-dialog>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import PortalSignalement from "@/components/PortalSignalement";
import PortalKm from "@/components/PortalKm.vue";
import { getSrStatusText } from "@/shared/Helper";
import { formatMagicDate } from "@/shared/DateHelper";
import { mapGetters, mapActions } from "vuex";
import MaximoService from "@/services/MaximoService";

export default {
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    PortalSignalement,
    PortalKm,
  },
  data() {
    return {
      ecmList: [],
      assetList: [],
      tab: null,
      asset: null,
      workorder: null,
      remark: null,
      wheelsets: [],
      wheelsetsNums: [],
      homologations: [],
      calcduedate: '',
      pleft: '',
      selectedAsset: '',
      meterKMdatas: [],
      meterHMdatas: [],
      srs: [],
      search: '',
      signalDialog: false,
      kmDialog: false,
    }
  },
  title: "Info locomotive",
  methods: {
    ...mapActions("carpet", {
      getAllLocos: "loadAllAssets"
    }),
    initReferential() {
      MaximoService.loadAssetNums().then(({ data }) => {
        this.assetList = data.locomotives;
        this.ecmList = data.maintainers;
      });
    },
    async filterByEcm(code) {
      if (!code) {
        const { data } = await MaximoService.loadAssetNums();
        this.assetList = data.locomotives;
        return;
      }
      const { data } = await MaximoService.loadAssetByCompany(code);
      this.assetList = data;
    },
    loadLoco(loconum) {
      MaximoService.getAssetByAssetnum(loconum).then(({ data }) => {
        this.asset = data;
        this.workorder = data?.workorder;
      });
      
      MaximoService.getNextMaintenancePlan(loconum).then(({ data }) => {
        this.calcduedate = data.calcduedate;
        this.pleft = data.pleft;
      });
      
      MaximoService.getWheelsetMeasureDates(loconum).then(({ data }) => {
        this.wheelsets = data;
      });
      
      MaximoService.getMeterdataByAsset(loconum).then(({ data }) => {
        this.meterKMdatas = data.filter(m => m.metername == "MILEAGE");
        this.meterHMdatas = data.filter(m => m.metername == "H0URS");
      });
      
      MaximoService.getOpenSrByAsset('internal', loconum).then(({ data }) => {
        this.srs = data;
      });
      
      MaximoService.getWheelsets(loconum).then(({ data }) => {
        this.wheelsetsNums = data;
      });
    },
    formatdate(date) {
      return formatMagicDate(date, this.$i18n.locale);
    },
    getSource(readingsource) {
      return readingsource == "CX_INTSAGE" ? 
        this.$t("message.pageHm.portalReal", { value: "default" }) :
        this.$t("message.pageHm.maintenanceReal", { value: "default" });
    },
    getSrStatusText(state) {
      return this.$t(getSrStatusText(state), { value: "default" });
    },
    checkWo(item) {
      if (item?.doclinksid != null) {
        return true
      }
      return false
    },
    setSignalement(bool) {
      this.signalDialog = bool;
    },
    setKm(bool) {
      this.kmDialog = bool;
    },
  },
  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),
    ...mapGetters("carpet", {
      getterAssets: "getAssets"
    }),
    modalAssetList() {
      return this.selectedAsset ? [this.selectedAsset] : this.assetList;
    },
    headerSrTable() {
      return [{
        text: this.$t("message.magic.id", { value: "default" }),
        value: "ticketid",
        sortable: true,
      },
      {
        text: this.$t("message.magic.description", { value: "default" }),
        value: "title",
        sortable: true,
      },
      {
        text: this.$t("message.magic.status", { value: "default" }),
        value: "status",
        sortable: true,
      },
      {
        text: this.$t("message.magic.date", { value: "default" }),
        value: "reportdate",
        sortable: true,
      },
      {
        text: this.$t("message.magic.details", { value: "default" }),
        value: "action",
        sortable: false,
      },
      ];
    },
    headerMeterTable() {
      return [{
        text: this.$t("message.magic.date", { value: "default" }),
        value: "readingdate",
        sortable: true,
      },
      {
        text: this.$t("message.magic.meter", { value: "default" }),
        value: "reading",
        sortable: true,
      },
      {
        text: this.$t("message.magic.source", { value: "default" }),
        value: "readingsource",
        sortable: true,
      },
      ];
    },
    getExportColumns() {
      return [{
        label: this.$t("message.page.loconumber", { value: "default" }),
        field: "assetnum",
      },
      {
        label: this.$t("message.magic.date", { value: "default" }),
        field: "readingdate",
        dataFormat: this.formatdate
      },
      {
        label: this.$t("message.magic.meter", { value: "default" }),
        field: "reading",
      },
      {
        label: this.$t("message.magic.source", { value: "default" }),
        field: "readingsource",
        dataFormat: this.getSource
      },
      ];
    },
  },
  mounted() {
    this.initReferential();
  }
}
</script>

<style scoped>
.v-expansion-panel-header {
  color: #fff;
}

.portal-deep-blue-bg {
  padding: 5px 0px 5px 10px;
  color: #fff;
  text-transform: uppercase;
}

.dp {
  color: #00475a;
  font-weight: bolder;
}
.dp-gray.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>th.shrink {
  white-space:nowrap;
}

.dp-gray.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  background-color: #c4c7c9;
  font-weight: bolder;
  color: #00475a;
  text-align: center;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  text-align: center;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 14px;
}

.value {
  font-size: 16px;
}

.schema-text {
  font-size: 10px;
}

.tab-content {
  width: 100%;
}
</style>